import React, { useState, useEffect, useRef } from "react";
import { FaStar, FaArrowLeft, FaArrowRight, FaPlus, FaMinus } from "react-icons/fa"; // Import arrow icons
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// Import required modules
import { Navigation, Pagination } from "swiper/modules";
import axios from "axios";
import { Link } from "react-router-dom";
import { addToCart, getCartCount} from "../../../utils/cartUtils";
import { useNavigate } from "react-router-dom";
import { LiaTimesSolid } from "react-icons/lia";
import { TfiRulerAlt } from "react-icons/tfi";

const styles = `
  @keyframes wiggle {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-3px); }
    50% { transform: translateX(3px); }
    75% { transform: translateX(-3px); }
  }
  .wiggle {
    animation: wiggle 0.2s ease-in-out 3;
  }
  .disabled-overlay::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 8%;
    right: 8%;
    height: 1px;
    background-color: #9ca3af; /* gray-400 */
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

const Product0 = ({ data }) => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [themeColor, setThemeColor] = useState("#63666A");
  const swiperRef0 = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);
  const [showSizeChart, setShowSizeChart] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [selectedSizePrice, setSelectedSizePrice] = useState(null);
  const navigate = useNavigate();
  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const admin_auto_id = sessionStorage.getItem('admin_auto_id');
  const app_type_id = sessionStorage.getItem('app_type_id');
  const [message, setMessage] = useState(null);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  const clearMessage = () => {
    setTimeout(() => {
      setMessage(null);
    }, 2000); // Clear message after 2 seconds
  };

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  // Fetch marketing keys
  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);
 
  // Set random stocks based on marketing keys
  useEffect(() => {
    if (isMarketingKeysLoading || !selectedProduct) {
      return;
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock && selectedProduct.size?.length > 0) {
      const stock = parseInt(quantityLeftFactualValue, 10);
      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(selectedProduct.size.map(() => 0));
      } else {
        const newRandomStocks = selectedProduct.size.map(() =>
          Math.floor(Math.random() * stock) + 1
        );
        setRandomStocks(newRandomStocks);
      }
    } else {
      const originalStocks = selectedProduct.size.map((size) =>
        parseInt(size.size_stock, 10)
      );
      setRandomStocks(originalStocks);
    }
  }, [isMarketingKeysLoading, selectedProduct, quantityLeftFactualValue]);

  const fetchSizeChart = async () => {
    // If already visible, just hide it
    if (showSizeChart) {
      setShowSizeChart(false);
      return;
    }

    // If image already fetched, just show it
    if (chartImage) {
      setShowSizeChart(true);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
        {
          admin_auto_id,
          app_type_id,
        }
      );

      if (response.data.status === "1" && response.data.getalldata.length > 0) {
        const img = response.data.getalldata[0].chart_image;
        const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img}`;
        const img2 = response.data.getalldata[0].international_size_chart;
        const imageUrl2 = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img2}`;
        setChartImage(imageUrl);
        setChartImage2(imageUrl2);
        setShowSizeChart(true);
      } else {
        setMessage("Size chart not available.");
      }
    } catch (error) {
      console.error("Failed to load size chart:", error);
    } finally {
      clearMessage();

    }
  };



  useEffect(() => {
    const fetchProducts = async () => { 
      try {
        const adminId = sessionStorage.getItem("admin_auto_id");
        const appTypeId = sessionStorage.getItem("app_type_id");
        const accessToken = sessionStorage.getItem("accessToken");
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_new_product_list`,
          {
            customer_auto_id: adminId || accessToken ,
            admin_auto_id: adminId,
            app_type_id: appTypeId,
            component_auto_id: data._id,
            component_type: "Products",
            limit: 6,
            page_number: 1,
          }
        );

        if (
          response.data.status === 1 &&
          Array.isArray(response.data.get_products_lists) &&
          response.data.get_products_lists.length > 0
        ) {
          const formattedProducts = response.data.get_products_lists.map(
            (product) => ({
              productAutoId: product.product_auto_id,
              name: product.product_name,
              rating: product.avg_rating,
              reviews: product.total_no_of_reviews,
              originalPrice: `Rs. ${product.product_price}`,
              discount: `${product.offer_percentage}% off`,
              price: ` ${product.final_product_price}`,
              images: Array.isArray(product.product_images)
                ? product.product_images.map(
                  (img) =>
                    `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
                )
                : [],
              onSale: product.new_arrival === "Yes",
              user_auto_id: product.user_auto_id,
              size: product.size,
              get_price_lists: product.get_price_lists,
              offer_data: product.offer_data,
              moq: product.moq,
              description: product.description,
            })
          );
          setProducts(formattedProducts);

        } else {
          setProducts([]); // Set products to empty array if no products exist
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedProduct]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  if (loading || products.length === 0) {
    return null;
  }

  return (
    <div
      className={`p-4  relative`}
      style={{
        backgroundColor: data.web_background_color,
      }}
    >
      <style>{styles}</style>
      <h1
        className={`text-2xl font-bold mb-4 ${data.web_title_font} text-${data.title_alignment}`}
        style={{
          color: data.web_title_color,
        }}
      >
        {data.title}
      </h1>

      {/* Swiper Slider */}
      <Swiper
        ref={swiperRef0}
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={1}
        navigation={{
          nextEl: `.custom-next-${data._id}`,
          prevEl: `.custom-prev-${data._id}`,
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning); // Update isBeginning state
          setIsEnd(swiper.isEnd); // Update isEnd state
        }}
        onInit={(swiper) => {
          setIsBeginning(swiper.isBeginning); // Initialize isBeginning state
          setIsEnd(swiper.isEnd); // Initialize isEnd state
        }}
      >
        {products.map((product, index) => (
          <SwiperSlide key={index}>
            <Link
              to={`/product-detail/${product.productAutoId}`}
              className="no-underline text-inherit"
            >
              <div className="relative border rounded-lg ">
                {/* Sale Tag */}
                {product.onSale && (
                  <div
                    className="absolute px-3 py-1 text-sm font-bold text-black top-2 left-2 rounded-xl"
                    style={{
                      backgroundColor: themeColor,
                    }}
                  >
                    New Arrival
                  </div>
                )}
                <img
                  src={
                    product.images && product.images.length > 0
                      ? product.images[0]
                      : "https://placehold.co/600x400"
                  }
                  alt={product.name}
                  className="object-cover w-full rounded-t-lg h-80"
                />
                <div className="p-2 bg-white ">
                  <h2 className="w-full mt-2 text-lg font-semibold truncate">
                    {product.name}
                  </h2>
                  <div className="flex items-center mt-2">
                    {/* Render star icons based on the rating */}
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        className={`${i < product.rating
                          ? "text-yellow-400"
                          : "text-gray-300"
                          } mr-2`}
                      />
                    ))}
                    <span className="ml-2 text-gray-600">
                      ({product.reviews})
                    </span>
                  </div>

                  <div className="mt-2 min-h-[23px]">
                    {product.discount &&
                      parseFloat(product.discount.replace("% off", "")) > 0 && (
                        <>
                          <span className="text-gray-500 line-through">
                            {product.originalPrice}
                          </span>
                          <span className="ml-2 text-red-600">
                            {product.discount}
                          </span>
                        </>
                      )}
                  </div>

                  <div className="font-bold">{product.price}</div>
                  {/* Add to Cart Button for all products */}
                  <button
                    className="w-full px-4 py-1 mt-2 text-black rounded"
                    style={{
                      backgroundColor: themeColor,
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedProduct(product);
                    }}
                  >
                    Add to cart
                  </button>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Arrows */}
      <div
        className={`custom-prev-${data._id
          } absolute top-1/2 left-2 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-lg ${isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
      >
        <FaArrowLeft className="text-xl text-gray-700" />
      </div>
      <div
        className={`custom-next-${data._id
          } absolute top-1/2 right-2 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-lg ${isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
      >
        <FaArrowRight className="text-xl text-gray-700" />
      </div>

      {/* Right Sidebar for Product Details */}
      {selectedProduct && (
        <div className="fixed inset-0 z-40 flex justify-end bg-opacity-30 backdrop-blur-sm">
          <div className="w-full sm:w-[500px] h-full bg-white shadow-lg transform transition-transform z-50 flex flex-col">
            {/* Header with title and close button */}
            <div className="flex items-center justify-between px-4 py-3">
              <p
                className="mb-0 text-lg font-bold text-black"
                onClick={() => setSelectedProduct(null)}
              >
                CHOOSE OPTION
              </p>
              <button
                className="text-xl text-gray-500"
                onClick={() => setSelectedProduct(null)}
              >
                <LiaTimesSolid />
              </button>
            </div>


            {/* Horizontal divider */}
            <div className="w-full h-px bg-gray-400"></div>
            <div className="relative flex-1 py-3 pl-10 pr-3 overflow-y-auto">
              {/* Product Image Slider */}
              <Swiper
                slidesPerView={2.5}
                spaceBetween={10}
                loop={selectedProduct.images && selectedProduct.images.length > 2}
                pagination={{ clickable: true }}

                className="mt-3 mb-3"
              >
                {selectedProduct.images && selectedProduct.images.length > 0 ? (
                  selectedProduct.images.map((image, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={image}
                        alt={`${selectedProduct.name} ${index + 1}`}
                        className="object-cover w-full h-72 "
                      />
                    </SwiperSlide>
                  ))
                ) : (
                  <SwiperSlide>
                    <img
                      src="https://placehold.co/600x400"
                      alt="No image available"
                      className="object-cover w-full rounded-lg h-60"
                    />
                  </SwiperSlide>
                )}
              </Swiper>

              <h2 className="text-lg font-bold truncate">{selectedProduct.name}</h2>
              <p className="mt-2 text-gray-600 truncate">{selectedProduct.description}</p>
              <div className="flex items-center justify-start mt-1">
                <span className="mr-3 text-lg font-semibold">
                  {`Rs. ${selectedSizePrice ? selectedSizePrice : selectedProduct.price
                    }`}
                </span>
                {selectedProduct.discount &&
                  parseFloat(selectedProduct.discount.replace("% off", "")) >
                  0 && (
                    <span className="text-sm text-gray-500 line-through">
                      {selectedProduct.originalPrice}
                    </span>
                  )}
              </div>

              {/* Size Selection */}
              {selectedProduct.size?.length > 0 && (
                <>
                  <div className="mt-3">
                    <div className="flex items-center justify-between ">
                      <label className="font-bold">Select</label>
                      {/* Size Chart Toggle */}
                      {(chartImage || chartImage2) && (
                        <div className="text-end">
                          <button
                            className="flex items-center justify-end gap-1 mt-2 text-black"
                            onClick={fetchSizeChart}
                          >

                            <TfiRulerAlt className="text-base" />
                            {showSizeChart ? (
                              <span className="underline">Size Chart</span>
                            ) : (
                              <>
                                <span className="underline">Size Chart</span>
                              </>
                            )}
                          </button>
                        </div>
                      )}

                    </div>

                    <div className="flex gap-2 mt-2">
                      {Array.isArray(selectedProduct?.size) &&
                        selectedProduct.size.map((sizeObj, index) => {
                          const actualStock = parseInt(sizeObj.size_stock, 10);
                          const isDisabled =
                            !actualStock || isNaN(actualStock) || actualStock <= 0;
                          const isSelected = selectedSize === sizeObj.size_name;
                          const displayStock = showStock
                            ? randomStocks[index]
                            : actualStock;
                          const showStockLabel =
                            actualStock > 0 &&
                            showStock &&
                            isQuantityLeftFactual &&
                            displayStock <= 5;

                          return (
                            <div key={sizeObj.size_auto_id} className="relative">
                              <button
                                className={`relative border w-20 h-12 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
                                  ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed disabled-overlay" : ""}
                                  ${!isDisabled && isSelected ? "text-white" : ""}`}
                                style={{
                                  backgroundColor:
                                    !isDisabled && isSelected ? themeColor : undefined,
                                  borderColor:
                                    !isDisabled && isSelected ? themeColor : undefined,
                                  color: !isDisabled && isSelected ? "#ffffff" : undefined,
                                }}
                                onClick={() => {
                                  if (isDisabled) return;
                                  setSelectedSize(sizeObj.size_name);
                                  setSelectedSizeId(sizeObj.size_auto_id);
                                  setSelectedStock(actualStock);
                                  const sizePriceObj =
                                    selectedProduct.get_price_lists[index];
                                  if (
                                    !sizePriceObj ||
                                    !sizePriceObj.final_size_price
                                  ) {
                                    setMessage("Size price not available");
                                    clearMessage();
                                    return;
                                  }
                                  setSelectedSizePrice(sizePriceObj.final_size_price);
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected && !isDisabled) {
                                    e.currentTarget.style.backgroundColor = themeColor;
                                    e.currentTarget.style.color = "#ffffff";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected && !isDisabled) {
                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                    e.currentTarget.style.color = "#000000";
                                  }
                                }}
                                disabled={isDisabled}
                              >
                                <span
                                  className={`text-base leading-none ${showStockLabel ? "mb-3" : ""
                                    }`}
                                >
                                  {sizeObj.size_name}
                                </span>
                                {showStockLabel && (
                                  <span
                                    className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                    style={{ backgroundColor: themeColor }}
                                  >
                                    {displayStock} left
                                  </span>
                                )}
                              </button>
                            </div>
                          );
                        })}
                    </div>
                  </div>



                  {showSizeChart && chartImage && (
                    <div className="p-2 mt-2 border rounded-lg">
                      <h3 className="mb-2 text-lg font-bold">Size Chart</h3>
                      <img
                        src={chartImage}
                        alt="Size Chart"
                        className="w-full h-auto rounded"
                      />

                      <h3 className="mb-2 text-lg font-bold">
                        {" "}
                        International Size Chart
                      </h3>
                      <img
                        src={chartImage2}
                        alt="Size Chart"
                        className="w-full h-auto rounded"
                      />
                    </div>
                  )}
                </>
              )}


              <div className="relative mt-5">

                {message && (
                  <div
                    className="p-2 mt-2 text-sm text-center bg-white "
                    style={{
                      color: message.includes("successfully") ? "green" : "red",
                    }}
                  >
                    {message}
                  </div>
                )}
                {/* Flex container for quantity control and add to cart button */}
                <div className="flex flex-row items-center gap-1">

                  {/* Quantity Control */}
                  <div className="flex items-center">
                    <button
                      className="bg-white px-2 py-[12px] border-l-2 border-t-2 border-b-2 border-gray-200   rounded-l-full"
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    >
                      <FaMinus />
                    </button>
                    <input
                      type="number"
                      min="1"
                      value={quantity}
                      onChange={(e) => {
                        const value = Math.max(1, parseInt(e.target.value));
                        setQuantity(value);
                      }}
                      className="w-11 text-center border-t-2 border-b-2 border-gray-200  py-[8px] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none appearance-none " />
                    <button
                      className="bg-white px-2 py-[12px] border-r-2 border-t-2 border-b-2  border-gray-200 rounded-r-full"
                      onClick={() => setQuantity(quantity + 1)}
                    >
                      <FaPlus />
                    </button>
                  </div>

                  {/* Add to Cart Button */}
                  <button
                    className={`flex-1 text-white py-[12px] rounded-full border ${selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                      ? "bg-gray-400 cursor-not-allowed"
                      : "cursor-pointer"
                      }`}
                    style={{
                      backgroundColor:
                        selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                          ? "#ccc"
                          : themeColor,
                    }}
                    onMouseEnter={(e) => {
                      if (!(selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0))) {
                        const darkenedColor = darkenHexColor(themeColor, 0.15);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                          ? "#ccc"
                          : themeColor;
                    }}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setMessage(null);

                      const moq = parseInt(selectedProduct?.moq || "1", 10);
                      const qty = parseInt(quantity, 10);

                      if (
                        selectedProduct.size?.length !== 0 &&
                        (!selectedSize || !selectedSizePrice)
                      ) {
                        setMessage("Please select a size");
                        clearMessage();
                        return;
                      }

                      if (selectedProduct.size?.length !== 0 && selectedStock === 0) {
                        setMessage("Selected size is out of stock");
                        clearMessage();
                        return;
                      }

                      if (qty < moq) {
                        setMessage(`Minimum order quantity is ${moq}`);
                        clearMessage();
                        return;
                      }

                      const payload = {
                        product_auto_id: selectedProduct.productAutoId,
                        added_by_id: selectedProduct.user_auto_id,
                        cart_quantity: qty,
                        ...(selectedProduct.size?.length !== 0 && {
                          size: selectedSizeId,
                          size_price: selectedSizePrice,
                        }),
                      };

                      try {
                        const res = await addToCart(payload);
                        await getCartCount();

                        if (res?.status === "1") {
                          setMessage(res.message);
                          clearMessage();
                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);
                        } else {
                          setMessage(res.message);
                          clearMessage();
                        }
                      } catch (error) {
                        setMessage(error.message);
                        clearMessage();
                        console.log("Failed to add to cart -", error);
                      }
                    }}
                  >
                    {selectedProduct.size?.length === 0
                      ? `Add to Cart | ₹ ${selectedProduct.price}`
                      : !selectedSize
                        ? "SELECT A SIZE"
                        : selectedStock === 0
                          ? "Size Out of Stock"
                          : `Add to Cart | ₹ ${selectedSizePrice}`}
                  </button>
                </div>


                <div className="mt-4 text-center">
                  <Link
                    to={`/product-detail/${selectedProduct.productAutoId}`}
                    className="text-inherit"
                  >
                    <button className="text-black underline ">View Details</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Product0;
